import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import { fetchAirlinesDeleted, doDeleteAirline } from 'actions/airlineException';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { AirlineResponse } from 'models/airlineException';
import AirlinesException from 'screens/components/AirlineException';
import { extractErrorMessage } from 'utils/generic';

const AirlinesExceptionContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<AirlineResponse[]>([]);
  const [show, setShow] = useState(false);

  const { t } = useStoreTranslation();
  const toast = useToast();
  const history = useHistory();

  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId) || '';

  const handleShow = () => setShow(!show);
  const handleReturn = () => history.goBack();

  const fetchData = () => {
    setIsLoading(true);
    fetchAirlinesDeleted(companyId).then((res) => {
      setData(res.data.data);
      setIsLoading(false);
    });
  };

  const saveExcludedCallBack = () => {
    setShow(false);
    toast.add({ type: 'success', message: t('airlineException.successAdd') });
    fetchData();
  };

  const handleDelete = (airlineId: string) => {
    doDeleteAirline(airlineId)
      .then(() => {
        fetchData();
        toast.add({
          type: 'success',
          message: t('airlineException.successDelete'),
        });
      })
      .catch((error) => {
        toast.add({
          type: 'danger',
          message: extractErrorMessage(error) || t('defaultError.default'),
        });
      });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AirlinesException
      show={show}
      airlines={data}
      isLoading={isLoading}
      companyId={companyId}
      onShow={handleShow}
      onReturn={handleReturn}
      onDelete={handleDelete}
      onSaveExcluded={saveExcludedCallBack}
    />
  );
};

export default AirlinesExceptionContainer;
